export const FETCH_USER_FLAGS_SUCCESS = 'FETCH_USER_FLAGS_SUCCESS';
export const FETCH_USER_FLAGS_FAILED = 'FETCH_USER_FLAGS_FAILED';
export const USER_FLAG_UPDATED = 'USER_FLAG_UPDATED';

const FF_REGEX = /^ad(gen|studio)-/;

function getAllFlags(flags = []) {
  return flags.reduce((obj, { featureName, cell }) => {
    if (FF_REGEX.test(featureName)) {
      return { ...obj, [featureName]: cell };
    }

    return obj;
  }, {});
}

export function fetchUserFlagsSuccess({ flags }) {
  return {
    type: FETCH_USER_FLAGS_SUCCESS,
    flags: getAllFlags(flags),
  };
}

export function fetchUserFlagsFailed(err) {
  return {
    type: FETCH_USER_FLAGS_FAILED,
    err,
  };
}

export function userFlagUpdated({ flag, value }) {
  return {
    type: USER_FLAG_UPDATED,
    flag,
    value,
  };
}



// WEBPACK FOOTER //
// ./src/actions/featureFlags.js